import * as React from "react";

const Trulia = () => (
  <svg
    width="122px"
    height="33px"
    viewBox="0 0 122 33"
    version="1.1"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      transform="translate(-685.000000, -1342.000000) translate(-17.000000, 1337.000000) translate(702.446797, 5.200000)"
      fill="#000"
      stroke="none"
      strokeWidth={1}
      fillRule="evenodd"
    >
      <ellipse
        fillRule="nonzero"
        cx="93.8860104"
        cy="3.1372549"
        rx="3.12953368"
        ry="3.1372549"
      />
      <path
        d="M31.64 32c-4.578 0-6.844-2.619-6.844-6.984V13.493h-4.141V8.997h4.14V3.236l5.45-1.354v7.115h5.709v4.496h-5.71v11.043c0 1.746.785 2.488 2.528 2.488 1.133 0 2.049-.043 3.53-.218v4.583A18.476 18.476 0 0 1 31.64 32zm19.697-18.017c-3.818 0-5.813 2.775-5.813 6.475V32h-5.466V9.093h4.598l.477 3.436c1.042-2.643 3.731-3.745 6.377-3.745.564 0 1.128.044 1.692.133v5.286a9.006 9.006 0 0 0-1.865-.22zm19.832 17.45l-.395-2.961C69.677 30.693 67.131 32 64.234 32c-4.873 0-7.902-3.267-7.902-8.102V8.784h5.487V22.68c0 2.657 1.054 4.312 3.95 4.312 1.274 0 2.152-.48 2.81-1.133 1.317-1.22 1.669-3.266 1.669-5.096V8.784h5.487v22.65h-4.566zm14.638-.06c-3.781 0-6.317-1.765-6.317-6.025V0h5.605v24.444c0 1.291.311 2.152 2.224 2.152.49 0 .623-.043.934-.043v4.518c-1.112.216-1.334.302-2.446.302z"
        fillRule="nonzero"
      />
      <polygon
        fillRule="nonzero"
        points="91.3823834 31.372549 91.3823834 8.78431373 97.015544 8.78431373 97.015544 31.372549 91.3823834 31.372549"
      />
      <path
        d="M118.14 31.787c-2.317 0-3.604-1.445-3.776-3.104-1.03 1.786-3.603 3.317-6.779 3.317-5.32 0-8.066-3.317-8.066-6.93 0-4.21 3.304-6.634 7.552-6.931l6.564-.468v-1.36c0-2.084-.73-3.487-3.776-3.487-2.488 0-3.947 1.105-4.076 3.146h-5.191c.3-4.975 4.29-7.186 9.267-7.186 3.819 0 7.08 1.191 8.367 4.507.557 1.404.643 2.977.643 4.465v8.206c0 1.02.343 1.403 1.244 1.403.344 0 .687-.085.687-.085v3.912c-.901.383-1.373.595-2.66.595zm-4.505-10.162l-5.664.425c-1.63.128-3.217 1.106-3.217 2.892 0 1.7 1.501 2.763 3.174 2.763 3.347 0 5.707-1.785 5.707-5.06v-1.02zM8.45 0C3.315.028 0 3.37 0 8.425c0 4.185 2.814 7.763 4.418 13.203.918 3.115 1.412 6.929 1.671 9.745h4.721c.26-2.816.753-6.63 1.672-9.745 1.603-5.44 4.417-9.018 4.417-13.203C16.9 3.371 13.585.028 8.45 0zm.027 12.877c-2.135 0-3.865-1.679-3.865-3.75 0-2.07 1.73-3.749 3.865-3.749 2.135 0 3.865 1.68 3.865 3.75 0 2.07-1.73 3.749-3.865 3.749z"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default Trulia;
